import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: (
        <svg viewBox="0 0 1024 1024">
          <path d="M810 276 C856 276, 897 293, 931 327 C965 361, 982 401, 982 449 L982 833 L896 833 L896 705 L128 705 L128 833 L42 833 L42 193 L128 193 L128 577 L470 577 L470 276Z  M388 494 C362 519, 332 532, 298 532 C263 532, 233 519, 208 494 C182 469, 170 439, 170 404 C170 369, 182 339, 208 314 C233 289, 263 276, 298 276 C332 276, 362 289, 388 314 C413 339, 425 369, 426 404 C425 439, 413 469, 388 494"/>
        </svg>
      ),
      title: "Действующая гостиница",
      description: "Проживание с базовым комфортом в формате гостевого дома."
    },
    {
      icon: (
        <svg viewBox="0 0 1024 1024">
          <path d="M854 128 L170 128 C147 128, 127 136, 111 153 C94 170, 86 190, 86 214 L86 810 C86 834, 94 854, 111 871 C127 888, 147 896, 170 896 L854 896 C876 896, 896 888, 913 871 C929 854, 938 834, 938 810 L938 214 C938 190, 929 170, 913 153 C896 136, 876 128, 854 128 Z M426 726 L214 726 L214 640 L426 640Z  M426 554 L214 554 L214 470 L426 470Z  M426 384 L214 384 L214 298 L426 298Z  M632 640 L512 518 L572 458 L632 520 L768 384 L828 444Z "/>
        </svg>
      ),
      title: "Официальное оформление",
      description: "Больше никаких проблем с проверками и трудоустройством."
    },
    {
      icon: (
        <svg viewBox="0 0 1024 1024">
          <path d="M874 726 C899 726, 919 734, 936 751 C952 768, 961 787, 961 810 L618 938 L319 854 L319 470 L403 470 L713 584 C735 593, 746 609, 746 632 C746 645, 742 657, 732 667 C722 677, 709 682, 695 682 L575 682 L501 654 L487 694 L575 726Z  M703 138 C733 103, 772 86, 819 86 C857 86, 890 100, 918 127 C945 154, 959 187, 959 226 C959 255, 945 290, 918 331 C889 372, 861 406, 833 433 C805 460, 761 501, 703 554 C644 501, 601 460, 573 433 C545 406, 516 372, 489 331 C460 290, 446 255, 447 226 C446 187, 460 154, 489 127 C516 100, 550 86, 589 86 C634 86, 672 103, 703 138 Z M63 470 L234 470 L234 938 L63 938Z "/>
        </svg>
      ),
      title: "Доброта и доверие",
      description: "Наш персонал, как и постояльцы - весьма положительные люди."
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className={`feature-item ${index === 1 ? 'feature-item-border' : ''}`} key={index}>
              <div className="feature-icon">
                {feature.icon}
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;